import Vue from 'vue';
import App from 'App.vue';
import { createRouter } from 'router';
import { createStore } from 'store';
import { sync } from 'vuex-router-sync';
import VueApollo from 'vue-apollo';
import VueGtm from 'vue-gtm';
import { createApolloClient } from './vue-apollo';

export function createApp (context) {
  const store = createStore();
  const router = createRouter();
  sync(store, router);

  const apolloClient = createApolloClient(context.ssr);
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient
  });

  const gtmID = process.env.VUE_APP_GTM_ID || false;
  if (gtmID) {
    Vue.use(VueGtm, {
      id: process.env.VUE_APP_GTM_ID,
      enabled: !context.ssr
    });
  }
  
  const app = new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
  });

  return { app, router, store, apolloProvider };
}
